import { API_URLS } from '../../constants';

// Environment configuration types
interface EnvironmentConfig {
  apiUrl: string;
  name: string;
}

// Environment configurations
const configs: Record<string, EnvironmentConfig> = {
  development: {
    apiUrl: API_URLS.DEVELOPMENT,
    name: 'development'
  },
  staging: {
    apiUrl: API_URLS.STAGING,
    name: 'staging'
  },
  production: {
    apiUrl: API_URLS.PRODUCTION,
    name: 'production'
  }
};

/**
 * Determines the current environment based on hostname
 */
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const hostname = window.location.hostname;

  // Determine environment based on hostname
  if (hostname === 'localhost' || hostname.startsWith('127.0.0.1') || hostname.includes('localhost')) {
    return configs.development;
  } else if (hostname.endsWith('.app.github.dev')) {
    return configs.development;
  } else if (hostname.includes('staging') || hostname.includes('dev') || hostname.includes('preview')) {
    return configs.staging;
  } else {
    return configs.production;
  }
};

/**
 * Get the API base URL based on environment
 */
export const getApiBaseUrl = (): string => {
  // First priority: Build-time embedded environment variable (from .env files or Azure build env)
  // CRA's DefinePlugin replaces process.env.REACT_APP_* at build time.
  // We reference it directly inside try/catch (not behind a typeof process
  // guard, which is always false in the browser with webpack 5).
  try {
    const envUrl = process.env.REACT_APP_API_BASE_URL;
    if (envUrl) {
      console.log(`Using API URL from build-time environment variable: ${envUrl}`);
      return envUrl;
    }
  } catch (error) {
    console.log('Build-time environment variable not available');
  }

  // For local development, use localhost API
  if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('127.0.0.1')) {
    const localApiUrl = API_URLS.LOCAL;
    console.log(`Using local API URL: ${localApiUrl}`);
    return localApiUrl;
  }

  // GitHub Codespaces: use same-origin (API requests are proxied through the
  // CRA dev server to localhost:8080 via setupProxy.js, avoiding CORS issues
  // with Codespaces' private port authentication).
  if (window.location.hostname.endsWith('.app.github.dev')) {
    console.log('Using Codespaces API URL: same-origin (proxied via dev server)');
    return '';
  }

  // Second priority: Hostname-based detection for different environments
  const config = getEnvironmentConfig();
  console.log(`Using API URL for ${config.name} environment: ${config.apiUrl}`);
  return config.apiUrl;
};